import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { getTitleColor } from "../../sUtils/eventColors";

export default function SCalendarLegend() {
  const [open, setOpen] = useState(false);

  const items = [
    { label: "Work / Projects", className: getTitleColor("Work / Projects", "event") },
    { label: "Travel / Driving", className: "text-black border-yellow-600 bg-yellow-100" },
    { label: "Van / Fusion Splicer", className: "text-black border-violet-600 bg-violet-100" },
    { label: "Office / Corporate", className: "text-black border-blue-600 bg-blue-100" },
    { label: "Rest / PTO / Personal Leave", className: "text-black border-green-600 bg-green-100" },
    { label: "Meeting", className: "text-black border-slate-600 bg-slate-300" },
    { label: "Training / Orientation", className: "text-black border-indigo-600 bg-indigo-300" },
    { label: "Closed / Holiday", className: "text-white border-black bg-black" },
    { label: "Birthdays", className: "text-black border-white-600 bg-orange-300" },
    { label: "No Job", className: "text-black border-gray-600 bg-gray-100" },
  ];

  return (
    <div className="mb-4">

      {/* Mobile Toggle */}
      <button
        onClick={() => setOpen(!open)}
        className="md:hidden flex items-center justify-between w-full px-4 py-2 bg-gray-100 rounded font-semibold"
      >
        Calendar Legend
        {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>

      {/* Legend Content */}
      <div
        className={`
          ${open ? "block" : "hidden"} 
          md:flex md:flex-wrap
          mt-3 md:mt-0
          gap-x-6 gap-y-3
          text-sm md:text-base font-semibold
        `}
      >
        {items.map((item, idx) => {
          const borderMatch = item.className.match(/border-[^\s]+/);
          const bgMatch = item.className.match(/bg-[^\s]+/);

          const borderClass = borderMatch ? borderMatch[0] : "border-gray-400";
          const bgClass = bgMatch ? bgMatch[0] : "bg-gray-100";

          return (
            <div
              key={idx}
              className="flex items-center space-x-3 w-1/2 md:w-auto"
            >
              <span
                className={`w-4 h-4 md:w-4 md:h-4 ${bgClass} ${borderClass} border-2 rounded`}
              />
              <span>{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
